import React from 'react';
import { FaThumbsUp, FaThumbsDown, FaTimes } from 'react-icons/fa';
import { useChatContext } from '../context/ChatContext';
import { useWebSocket } from '../hooks/useWebSocket';

const FeedbackSection = ({ message }) => {
  const { commentBoxId, commentText, dispatch } = useChatContext();
  const { sendFeedback } = useWebSocket();

  const handleFeedback = (feedback) => {
    dispatch({ type: 'SET_COMMENT_BOX_ID', payload: message.id });
    dispatch({ type: 'SET_COMMENT_TEXT', payload: { feedback, comment: '' } });
  };

  const submitComment = () => {
    const feedbackData = typeof commentText === 'object' ? commentText : { feedback: 'positive', comment: commentText };
    
    const data =
        typeof commentText === "object"
          ? commentText
          : { feedback: "positive", comment: String(commentText || "") };

    sendFeedback({
      feedback: data.feedback,
      comment: data.comment,
      messageText: message.text,
      responseId: message.responseId,    // ← from stream_complete
      timestamp: message.dbTimestamp,    // ← from stream_complete
    });
    
    dispatch({
      type: 'UPDATE_MESSAGE_BY_ID',
      payload: { id: message.id, updates: { feedback: feedbackData.feedback } }
    });
    
    dispatch({ type: 'SET_COMMENT_TEXT', payload: '' });
    dispatch({ type: 'SET_COMMENT_BOX_ID', payload: null });
  };

  if (message.isGreeting) return null;

  // Get current feedback selection (either from message or current selection)
  const currentFeedback = message.feedback || (typeof commentText === 'object' ? commentText.feedback : null);

  return (
    <>
      <div className="bubble-feedback">
        {message.feedback ? (
          <div className="feedback-confirmation">✓ Thank you!</div>
        ) : (
          <div className="feedback-buttons">
            <button 
              className={`thumb-up ${currentFeedback === 'positive' ? 'selected' : ''}`} 
              onClick={() => handleFeedback('positive')}
            >
              <FaThumbsUp />
            </button>
            <button 
              className={`thumb-down ${currentFeedback === 'negative' ? 'selected' : ''}`} 
              onClick={() => handleFeedback('negative')}
            >
              <FaThumbsDown />
            </button>
          </div>
        )}
      </div>

      {commentBoxId === message.id && (
        <div className="comment-box small">
          <div className="comment-header">
            <span>Comment (optional):</span>
            <button onClick={() => dispatch({ type: 'SET_COMMENT_BOX_ID', payload: null })}>
              <FaTimes />
            </button>
          </div>
          <textarea 
            value={typeof commentText === 'object' ? commentText.comment || '' : commentText} 
            onChange={e => dispatch({
              type: 'SET_COMMENT_TEXT',
              payload: typeof commentText === 'object' ? { ...commentText, comment: e.target.value } : e.target.value
            })} 
            placeholder="Your comment..." 
          />
          <button className="submit-comment" onClick={submitComment}>Submit</button>
        </div>
      )}
    </>
  );
};

export default FeedbackSection;